import { render, staticRenderFns } from "./SuspectedPlayersActionTable.vue?vue&type=template&id=cc1a7fd8&scoped=true&"
import script from "./SuspectedPlayersActionTable.vue?vue&type=script&lang=js&"
export * from "./SuspectedPlayersActionTable.vue?vue&type=script&lang=js&"
import style0 from "./SuspectedPlayersActionTable.vue?vue&type=style&index=0&id=cc1a7fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1a7fd8",
  null
  
)

export default component.exports